__turbopack_context__.v({
  "button": "Header-module-scss-module__oiPmda__button",
  "shrink": "Header-module-scss-module__oiPmda__shrink",
  "title": "Header-module-scss-module__oiPmda__title",
});
